<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="!deleting"
  [closeOnEscape]="!deleting"
  [dismissableMask]="!deleting"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()"
  styleClass="delete-confirmation-dialog"
  [style]="{ width: '450px' }">

  <ng-template pTemplate="header">
    <div class="dialog-header">
      <i class="pi pi-exclamation-triangle warning-icon"></i>
      <span>{{ title }}</span>
    </div>
  </ng-template>

  <div class="dialog-content">
    <p>{{ subtitle }}</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button
        i18n-label="@@common.cancel"
        label="Cancel"
        severity="secondary"
        [outlined]="true"
        (click)="onCancel()"
        [disabled]="deleting">
      </p-button>
      <p-button
        [label]="deleting ? deletingLabel : deleteLabel"
        severity="danger"
        [icon]="deleting ? 'pi pi-spin pi-spinner' : 'pi pi-trash'"
        (click)="onConfirm()"
        [disabled]="deleting"
        [loading]="deleting">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
